export const commonDateFieldTriggerTheme = {
   light: {
      borderColor: 'border-gray-300',
      background: 'bg-base-white',
      disabledBgColor: 'bg-gray-50',
      errorBorderColor: 'border-error-300'
   },
   dark: {}
}
